import styled from 'styled-components';

const StyledSliderItem = styled.div`
  padding: 56.25% 0 0 0;
  position: relative;
`;
export default StyledSliderItem;
